import { lazy } from "react";

export default function load(code) {
  switch (code) {
    case "balances/archive":
      return lazy(() => import("views/balances/archive"));
    case "balances/year":
      return lazy(() => import("views/balances/year"));
    case "balances/detail":
      return lazy(() => import("views/balances/detail"));
    case "balances/dashboard":
      return lazy(() => import("views/balances/dashboard"));
    case "balances/current-year":
      return lazy(() => import("views/balances/current-year"));
    case "balances/mapping":
      return lazy(() => import("views/balances/mapping"));
    default:
      return null;
  }
}
